__turbopack_context__.v({
  "className": "space_grotesk_68f1f060-module__ebX-7q__className",
});
